var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68 5v44.09h15.66l-5.46-7.4 15.71-26.15 15.7 26.15-5.46 7.4H57.5V5z",
    fill: "#204ECF",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.16 54.09H.68V0H62.5v54.09H44.02",
    stroke: "#204ECF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82 62.06v-8.7l8.27-11.21L31.39 16 15.68 42.15l8.28 11.21v8.7m7.22-23.03V16",
    stroke: "#204ECF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.68,
    cy: 39,
    fill: "#204ECF",
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/DigitalMarketing.f1d5436d991c64c45955b27f0e99c442.svg";
export { ForwardRef as ReactComponent };